import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetApplicationInformatio = createAsyncThunk(
  "ApplicationInformatio/GetApplicationInformatio",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ApplicantInformation/GetApplicationInformationData",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListSecondarySectors = createAsyncThunk(
  "SecondarySectors/GetListSecondarySectors",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_SecondarySectors/GetListAI_SecondarySectors",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      
      console.log(data, "sssssss");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ChangeApplicationStatus = createAsyncThunk(
  "ChangeAppicationStaus/ChangeApplicationStatus",
  async (ApplicationStatus, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ChangeAppicationStaus/ChangeApplicationStatus",
        {
          aI_ApplicationInformationId:
            ApplicationStatus.aI_ApplicationInformationId,
          aI_ApplicationStatusId: ApplicationStatus.aI_ApplicationStatusId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetActiveRound = createAsyncThunk(
  "ApplicantInformation/GetActiveRound",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ApplicantInformation/GetActiveRound",
        {}
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const UpdateAI_GrantsProgram = createAsyncThunk(
  "UpdateAI_GrantsProgram",
  async (Application, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ApplicantInformation/UpdateAI_GrantsProgram",
        {
          aI_ApplicationInformationId:
            Application.aI_ApplicationInformationId,
            aI_GrantsProgramId: Application.aI_GrantsProgramId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const ApplicationInformation = createSlice({
  name: "ApplicationInformation",
  initialState: {
    ApplicationInformation: {},
    loadingApplicationInformation: false,
    errorApplicationInformation: null,

    ListSecondarySectors: [],
    loadingListSecondarySectors: false,
    errorListSecondarySectors: null,

    ApplicationStatus: "",
    loadingApplicationStatus: false,
    errorApplicationStatus: null,

    ActiveRound: 0,
    loadingActiveRound: false,
    errorActiveRound: null,

    updateaI_GrantsProgramId: {},
    loadingupdateaI_GrantsProgramId: false,
    errorupdateaI_GrantsProgramId: null,
  },
  reducers: {
    SetApplicationInformation: (state, action) => {
      state.ApplicationInformation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetApplicationInformatio.pending, (state, action) => {
        state.loadingApplicationInformation = true;
        state.ApplicationInformation = action.payload;
        state.errorApplicationInformation = null;
      })
      .addCase(GetApplicationInformatio.fulfilled, (state, action) => {
        state.loadingApplicationInformation = false;
        state.ApplicationInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetApplicationInformatio.rejected, (state, action) => {
        state.loadingApplicationInformation = false;
        state.errorApplicationInformation = action.payload;
      })
      .addCase(GetListSecondarySectors.pending, (state, action) => {
        state.loadingListSecondarySectors = true;
        state.ListSecondarySectors = action.payload;
        state.errorListSecondarySectors = null;
      })
      .addCase(GetListSecondarySectors.fulfilled, (state, action) => {
        state.loadingListSecondarySectors = false;
        state.ListSecondarySectors = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListSecondarySectors.rejected, (state, action) => {
        state.loadingListSecondarySectors = false;
        state.errorListSecondarySectors = action.payload;
      })

      .addCase(ChangeApplicationStatus.pending, (state, action) => {
        state.loadingApplicationStatus = true;
        state.ApplicationStatus = action.payload;
        state.errorApplicationStatus = null;
      })
      .addCase(ChangeApplicationStatus.fulfilled, (state, action) => {
        state.loadingApplicationStatus = false;
        state.ApplicationStatus = action.payload; // Assuming payload has the desired data
      })
      .addCase(ChangeApplicationStatus.rejected, (state, action) => {
        state.loadingApplicationStatus = false;
        state.errorApplicationStatus = action.payload;
      })

      .addCase(GetActiveRound.pending, (state, action) => {
        state.loadingActiveRound = true;
        state.ActiveRound = action.payload;
        state.errorActiveRound = null;
      })
      .addCase(GetActiveRound.fulfilled, (state, action) => {
        state.loadingActiveRound = false;
        state.ActiveRound = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetActiveRound.rejected, (state, action) => {
        state.loadingActiveRound = false;
        state.errorActiveRound = action.payload;
      })
      
      
      .addCase(UpdateAI_GrantsProgram.pending, (state, action) => {
        state.loadingupdateaI_GrantsProgramId= true;
        state.updateaI_GrantsProgramId = action.payload;
        state.errorupdateaI_GrantsProgramId = null;
      })
      .addCase(UpdateAI_GrantsProgram.fulfilled, (state, action) => {
        state.loadingupdateaI_GrantsProgramId = false;
        state.updateaI_GrantsProgramId = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateAI_GrantsProgram.rejected, (state, action) => {
        state.loadingupdateaI_GrantsProgramId = false;
        state.errorupdateaI_GrantsProgramId = action.payload;
      })
      
      ;
  },
});
export const { SetApplicationInformation } = ApplicationInformation.actions;

export default ApplicationInformation.reducer;
